import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutCreditOverrides extends Layout {
    panelCreditOverrides: Panel;
    sourceCreditOverride: DataSource;
    tableCreditOverride: Table;
}
